"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConnectedCalculationWidgetScreen = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _DefaultCanvasProvider = require("../../Shared/Providers/DefaultCanvasProvider");
var _CalculationWidget = _interopRequireDefault(require("./Containers/CalculationWidget"));
var _Error = _interopRequireDefault(require("../../Shared/Containers/Error"));
var _Confirm = _interopRequireDefault(require("./Containers/Confirm"));
var _ThemeProvider = _interopRequireDefault(require("./ThemeProvider"));
require("./Components/Styles.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Main Screen of the configurator
 */
var CalculationWidgetScreen = function CalculationWidgetScreen(props) {
  var renderError = props.renderError,
    renderConfirm = props.renderConfirm,
    renderWidget = props.renderWidget,
    CanvasProvider = props.CanvasProvider,
    ThemeProvider = props.ThemeProvider;
  return /*#__PURE__*/React.createElement(CanvasProvider, null, /*#__PURE__*/React.createElement(ThemeProvider, null, renderWidget(), renderError(), renderConfirm()));
};
CalculationWidgetScreen.defaultProps = {
  // Render props
  renderWidget: function renderWidget() {
    return /*#__PURE__*/React.createElement(_CalculationWidget["default"], null);
  },
  renderError: function renderError() {
    return /*#__PURE__*/React.createElement(_Error["default"], null);
  },
  renderConfirm: function renderConfirm() {
    return /*#__PURE__*/React.createElement(_Confirm["default"], null);
  },
  // Components
  CanvasProvider: _DefaultCanvasProvider.DefaultCanvasProvider,
  ThemeProvider: _ThemeProvider["default"]
};

// Export the non connected Screen
var _default = exports["default"] = CalculationWidgetScreen;
var mapStateToProps = function mapStateToProps(state) {
  var selectedDesignArea = state.designArea.selectedDesignArea;
  return {
    selectedDesignArea: selectedDesignArea
  };
};
var ConnectedCalculationWidgetScreen = exports.ConnectedCalculationWidgetScreen = (0, _reactRedux.connect)(mapStateToProps)(CalculationWidgetScreen);